import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) => ({
    driverDetailsTabContainer: {

    },
    driverInfoCard: {
        padding: "2em 2.75em",
        [theme.breakpoints.up("sm")]: {
            display: "flex",
            flexDirection: 'column',
            height: '100%'
        },
    },
    mainContainer: {
        margin: theme.spacing(0.5, 0, 0.2),
        position: 'relative',
        overflow: 'hidden'
    },
    mapsContainer: {
        height: 'calc(100vh - 187px)',
        zIndex: 1,
        position: 'relative'
    },
    leftDrawerContainer: {
        top: '0',
        left: '-25%',
        position: 'absolute',
        width: '25%',
        height: "100%",
        background: 'white',
        maxWidth: '450px',
        minWidth: '400px',
        boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
        zIndex: 10,
        transition: 'left 0.3s ease-out'
    },
    leftDrawerContainerButtonBox: {
        position: 'absolute',
        top: '10px',
        right: '-36px',
        width: '36px',
        height: '32px',
        backgroundColor: theme.palette.primary.main,
        borderRadius: '0 16px 16px 0',
        cursor: 'pointer'
    },
    leftDrawerContainerButtonIcon: {
        margin: '3px 0 3px 10px'
    },
    searchBox: {
        padding: theme.spacing(0.50, 3, 0.50, 3),
        // backgroundColor: '#c0bcbc7a'
    },
    sideBarSearchView: {
        display: 'flex',
        alignItems: 'center',
        justify: "space-between"
    },
    search: {
        marginLeft: "auto",
        marginBottom: "0",
        "& .MuiInputBase-root": {
            maxWidth: '100%',
            padding: 5,
            borderRadius: 30,
            border: "unset",
            position: "relative",
            marginRight: 0,
            backgroundColor: "#edf4fb",
            [theme.breakpoints.up("md")]: {
                // width: 300,
            },
        },
        "& .MuiInputBase-root::before": {
            content: "unset",
        },
        "& .MuiInputBase-root::after": {
            content: "unset",
        },
        "& .MuiFormLabel-root": {
            paddingLeft: 10,
            color: "#AEB2BA",
            position: "relative",
            zIndex: 2,
            top: 20,
            left: 10,
        },
        "& .MuiFormLabel-root.Mui-focused": {
            paddingLeft: 10,
            color: theme.palette.primary.main,
            position: "relative",
            zIndex: 2,
            top: 0,
            left: 0,
        },
        "& .MuiFormLabel-root.MuiFormLabel-filled": {
            paddingLeft: 10,
            color: theme.palette.primary.main,
            position: "relative",
            zIndex: 2,
            top: 0,
            left: 0,
        },
        "& ::placeholder": {
            opacity: 0.8,
            fontSize: '14px'
        }
    },
    searchIcon: {
        width: '14px',
        margin: '4px'
    },
    filterIcon: {
        fontSize: 30,
        margin: '0 0 0 16px',
        marginRight: 0,
        marginLeft: 'auto'
    },
    tripsListBoxContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    tripsListBox: {
        flex: '1 1 0%',
        overflow: 'auto'
    },
    tripsListItem: {
        padding: theme.spacing(1.25, 4, 1.25, 4),
        cursor: 'pointer',
    },
    tripsListItemSelected: {
        backgroundColor: 'rgba(255,212,40,.10)'
    },
    tripsListItemRow: {
        display: 'flex'
    },
    tripsListItemRowCenter: {
        alignItems: 'center'
    },
    tripsListItemIconBox: {
        marginTop: theme.typography.pxToRem(2)
    },
    tripsListItemIconStart: {
        width: theme.typography.pxToRem(12),
        height: theme.typography.pxToRem(12),
        background: 'rgb(237,244,251)',
        borderRadius: theme.typography.pxToRem(12),
    },
    tripsListItemIconEnd: {
        width: theme.typography.pxToRem(12),
        height: theme.typography.pxToRem(12),
        background: 'rgb(237,244,251)'
    },
    dottedLine: {
        borderLeft: '3px dashed',
        borderColor: 'rgb(237, 244, 251)',
        marginLeft: '4px',
        marginTop: '1px',
        height: '75%',
    },
    tripsListItemSideBox: {
        padding: theme.spacing(0, 0, 1, 0.5)
    },
    eventAddress: {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
        color: 'black'
    },
    eventNoAddress: {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
        color: 'rgb(177,177,177)'
    },
    eventDate: {
        fontSize: theme.typography.pxToRem(10),
        color: 'rgb(177,177,177)'
    },
    eventsSeverityIcon: {
        margin: theme.spacing(0, 1, 0, 2)
    },
    eventsIcon: {
        width: theme.typography.pxToRem(15),
        height: theme.typography.pxToRem(15),
    },
    eventsSeverityCount: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 500
    },
    rightMainContainer: {
        position: "absolute",
        top: 0,
        zIndex: 1,
        right: 0,
        margin: theme.spacing(2, 2, 0, 0)
    },
    eventsType: {
        backgroundColor: 'rgb(222,205,254)',
        fontSize: theme.typography.pxToRem(14),
        fontWeight: 700,
        padding: theme.spacing(0.3, 2),
        borderRadius: '10px',
        whiteSpace: 'nowrap'
    },
    tripCardDrawerButton: {
        top: '10px',
        left: '-36px',
        width: '36px',
        cursor: 'pointer',
        height: '32px',
        position: 'absolute',
        borderRadius: '16px 0px 0px 16px',
        backgroundColor: '#F9D13B'
    },
}));